import { toBase64 } from '../../../../utils/index.js';
import { BaseWasmQuery } from '../../BaseWasmQuery.js';
export class QueryGetPrices extends BaseWasmQuery {
    toPayload() {
        return toBase64({
            get_prices: {
                assets: this.params.assets,
            },
        });
    }
}
